import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'

type ClinicBrandLogoProps = {
  logoUrl?: string | null
  companyName?: string | null
  compact?: boolean
  className?: string
}

export function ClinicBrandLogo({
  logoUrl,
  companyName,
  compact = false,
  className,
}: ClinicBrandLogoProps) {
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    setFailed(false)
  }, [logoUrl])

  if (!logoUrl || failed) return null

  return (
    <div className={cn('min-w-0 items-center justify-center', className)}>
      <img
        src={logoUrl}
        alt={`Logo ${companyName || 'clinica'}`}
        className={cn(
          'block w-auto object-contain',
          compact ? 'max-h-6 max-w-[4.5rem]' : 'max-h-8 max-w-36'
        )}
        onError={() => setFailed(true)}
      />
    </div>
  )
}
